
	<div class="bg-login">
		<div class="container h-100">
		<div class="wrap text-center h-100 align-content-center">
			<div class="col-12 row m-0 p-0">
				<div class="col-3"></div>
				<div class="col-12 col-lg-6 bg-f-w justify-content-center z-100">
					<div class="col-12 m-0 row">
						<div class="col-3"></div>
						<div class="col-12 col-md-6 p-0 mt-4">
							<div class="col-12 text-center p-0 mt-4">
								<img src="../../assets/images/rekruu_logo.png" alt="" height="110" class="mx-auto">
								<h4 class="semiboldtextblue80024 mt-4">Uusi salasana</h4>
								<p class="normaltextblue90016 f-os mt-2">Lisää sähköpostiosoitteesi ja lähetämme sinulle aktivointikoodin.</p>
							</div>
						</div>
						<div class="col-3"></div>
			
					</div>
			
					<div class="col-12 p-0 row m-0">
						<div class="col-1"></div>
						<div class="col-12 col-md-10 p-0">
							<div class="col-12 p-0 ">
								<div class="col-12 login-form-bg">
									<div id="loader" class="loader-container mt-4 mb-4" style="display:none">
										<div class="loader mx-auto"></div>
										<p class="body2b-b text-center mt-4 mb-4">Linkkiä lähetetään...</p>
									</div>
									<form class="flex-row " id="forgot-form" [formGroup]="forgotForm"
									(ngSubmit)="forgotPassword()">
									<div class="col-12 row m-0 pt-2">
										<div class="alert alert-success" *ngIf="was_successfull">
											<p class="text-center mb-0">Aktivointikoodin lähettäminen onnistui. Siirry sähköpostiisi jatkaaksesi.</p>
										</div>
										<div class="form-floating mb-2  col-12 col-md-12 p-0">
											<input type="email" placeholder="Sähköposti" formControlName="userName" id="userName" class="form-control" [class.invalid-input]="userName.errors && userName.touched" required>
											<label for="userName">Sähköposti</label>
										</div>
									</div>
									<div class=" mx-auto mt-2 mb-4">
										<div class="text-center" >
											<button  [disabled]="forgotForm.invalid" class="btn btn-formed-main-blue w-100"><i class="far fa-paper-plane me-2"></i>Lähetä</button>
										</div>
									</div>
								</form>
							
						</div>
							</div>
						</div>
						<div class="col-1"></div>
			
					</div>
			
				</div>
				<div class="col-3"></div>
			</div>
	
		</div>
		</div>
	
			<div class="bubbles">
				<div class="bubble"></div>
				<div class="bubble"></div>
				<div class="bubble"></div>
				<div class="bubble"></div>
				<div class="bubble"></div>
				<div class="bubble"></div>
				<div class="bubble"></div>
				<div class="bubble"></div>
				<div class="bubble"></div>
				<div class="bubble"></div>
			  </div>
	</div>
	
	
	